// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ih-0";
export var assigneeDetails = "_ih-1";
export var assigneeInfo = "_ih-2";
export var dropdownContainer = "_ih-4";
export var dropdownImage = "_ih-5";
export var editAssigneeInfo = "_ih-3";
export var editAssigneeModalContainer = "_ih-6";
export var hidden = "_ih-8";
export var input = "_ih-7";